import * as E from 'fp-ts/lib/Either';
import * as t from 'io-ts';
import {isString} from 'lodash';
import {DragEvent} from 'react';

/** Encode the given object as JSON suitable for drag & drop. */
export function makeDragAndDropJson(object: any) {
  return JSON.stringify(object);
}

/** Decode the given drag & drop data URI, if possible. */
export function parseDragAndDropJson<T extends t.Type<any>>(
  runtimeType: T,
  maybeJson: any,
): t.TypeOf<T> | undefined {
  if (!isString(maybeJson)) {
    return undefined;
  }

  // Parse the JSON data.
  const object = tryParseJson(maybeJson);

  // Decode the JSON data with the runtime type.
  const decodedObject = t.union([runtimeType, t.undefined]).decode(object);
  return E.getOrElse(() => undefined)(decodedObject);
}

function tryParseJson(text: string): any {
  try {
    return JSON.parse(text);
  } catch (e) {
    if (!(e instanceof SyntaxError)) {
      throw e;
    }

    return undefined;
  }
}

export function preventDragStart(e: DragEvent) {
  e.preventDefault();
}

export function addDownloadToDragEvent(
  e: DragEvent,
  options: {
    url: string;
    name: string;
  },
) {
  if (!e.nativeEvent.dataTransfer) {
    return;
  }

  const downloadName = options.name.replace(/:/g, '-');
  const data = `application/octet-stream:${downloadName}:${options.url}`;
  e.nativeEvent.dataTransfer.setData('DownloadURL', data);
  e.nativeEvent.dataTransfer.setData('text/uri-list', options.url);
}

export function addTextToDragEvent(e: DragEvent, text: string) {
  if (!e.nativeEvent.dataTransfer) {
    return;
  }

  e.nativeEvent.dataTransfer.setData('Text', text);
}
